import { makeContractsRepository } from 'modules/customer/infra/repositories';

import { FetchCustomerContractsUseCase } from './implementations/FetchCustomerContractsUseCase';

let instance: FetchCustomerContractsUseCase | null = null;

export default function makeFetchCustomerContractsUseCase() {
  if (!instance) {
    const repository = makeContractsRepository();

    instance = new FetchCustomerContractsUseCase(repository);
  }

  return instance;
}
